import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, IsDate } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { ExitReasonsEnum } from "@gtpl/shared-models/common-models";

export class ExitActionDTO{
    @ApiProperty()
    @IsNotEmpty({message: 'Exit action Id should not be empty'})
    @IsAlphanumeric()
    @IsOptional()
    exitActionId: number;

    @ApiProperty()
    @IsNotEmpty({message: 'Employee Id should not be empty'})
    @IsAlphanumeric()
    employeeId: number;
    

    @ApiProperty()
    @IsDate()
    exitDate: Date;

    @ApiProperty({
        enum: ExitReasonsEnum,
        default: ExitReasonsEnum.LACK_OF_CAREER_GROWTH,
    })
    @IsNotEmpty({message: 'Exit Reason should not be empty'})
    exitReason: ExitReasonsEnum;

    @ApiProperty()
    remarks: string;

    @ApiProperty()
    approvedBy: number;


    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: "Created User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Created User should be only alphabets"})
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: "Updated User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Updated User should be only alphabets"})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;
}